<template>
    <div>
        <div v-if="loginSuccess">
            Sikeres művelet!
        </div>
        <div class="w3-margin" v-if="!$store.getters.isLogin && !$store.getters.loginProcess && $store.getters.isProfileLoad">
                <div class="w3-modal-content " style="max-width:400px;">
                    <div class="flex-center-container">
                        <div v-if="!isRegistration" class="w3-center w3-margin w3-padding" style="">
                            <h4 class="page-title "><font-awesome-icon icon="sign-in-alt"></font-awesome-icon> BEJELENTKEZÉS</h4>                                    
                            <form @submit.prevent>
                                <label class="w3-text-blue w3-left">E-mail-cím</label>
                                <input v-model.trim="loginForm.email" type="email" class="w3-input w3-border w3-margin-bottom" id="email1" placeholder="Add meg az e-mail-címed">                
                                
                                <label class="w3-text-blue w3-left">Jelszó</label>
                                <input v-model.trim="loginForm.password" type="password" class="w3-input w3-border w3-margin-bottom" id="pwd1" placeholder="Add meg a jelszavad">                                

                                <div v-on:click="login('password')" class="w3-margin-bottom w3-button w3-padding w3-border w3-border-yellow w3-yellow w3-hover-white" style="width:300px"><font-awesome-icon icon='envelope'></font-awesome-icon> Belépés e-mail-címmel</div>                        
                                <div class="w3-button w3-border w3-green w3-border-green w3-hover-white" style="width:300px" v-on:click="passwordReset">Új jelszó beállítása</div>

                            </form>                                    
                            <hr class="theme-1" style="height:2px;">  
                            <div v-on:click="login('google')" class="w3-margin-bottom w3-button w3-border w3-border-red w3-padding w3-red w3-hover-white" style="width:300px"><font-awesome-icon fixed-width :icon="['fab', 'google']"></font-awesome-icon> Belépés Google-fiókkal</div> 
                            <div v-on:click="login('facebook')" class="w3-margin-bottom w3-button w3-border w3-border-blue w3-padding w3-blue w3-hover-white" style="width:300px"><font-awesome-icon fixed-width :icon="['fab', 'facebook']"></font-awesome-icon> Belépés Facebook-fiókkal</div>                            
                        </div>      
                    
                        <div v-if="isRegistration" class="w3-center w3-margin w3-padding " style="">
                            <h4 class="page-title "><font-awesome-icon icon="address-card"></font-awesome-icon> Regisztráció</h4>                                    
                            <form @submit.prevent>
                                <label class="w3-text-blue w3-left">Név</label>
                                <input v-model.trim="signupForm.displayName" type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Add meg a neved">                
                                <label class="w3-text-blue w3-left">E-mail</label>
                                <input v-model.trim="signupForm.email" type="email" class="w3-input w3-border w3-margin-bottom" placeholder="Add meg az e-mail-címed">                                                
                                <label class="w3-text-blue w3-left">Jelszó</label>
                                <input v-model.trim="signupForm.password" type="password" class="w3-input w3-border w3-margin-bottom" placeholder="Add meg a jelszavad">                                                
                                <label class="w3-text-blue w3-left">Jelszó újra</label>
                                <input v-model.trim="signupForm.password2" type="password" class="w3-input w3-border w3-margin-bottom" placeholder="Add meg a jelszavad újra">                                        
                                <div class="w3-margin w3-small"><input type="checkbox" v-model="isDataRules"> Az <span class="cursorpointer w3-text-blue" v-on:click="$openPage(1)">adatkezelési szabályzatot</span> elfogadom.</div>
                                <div v-on:click="signup" class="w3-margin-bottom w3-button w3-padding w3-border w3-border-yellow w3-yellow w3-hover-white" style="width:300px"><font-awesome-icon icon='envelope'></font-awesome-icon> Regisztráció e-mail-címmel</div>
                                <div v-on:click="login2('google')" class="w3-margin-bottom w3-button w3-padding w3-border w3-border-red w3-red w3-hover-white" style="width:300px"><font-awesome-icon fixed-width :icon="['fab', 'google']"></font-awesome-icon> Regisztráció Google-fiókkal</div> 
                                <div v-on:click="login2('facebook')" class="w3-margin-bottom w3-button w3-padding w3-border w3-border-blue w3-blue w3-hover-white" style="width:300px"><font-awesome-icon fixed-width :icon="['fab', 'facebook']"></font-awesome-icon> Regisztráció Facebook-fiókkal</div>                                                                  
                            </form>
                        </div>      
                    </div>  
                </div>
    
        </div>
    </div>
</template>

<script>
const fb = require('../firebase.js')
import {store} from "../store.js";
export default {
    name: 'Login',
    data() {
        return {
            isDataRules:false,
            isRegistration:false,
            loginForm: {
                email: '',
                password: ''
            },
            signupForm: {
                email: '',
                password: '',
                password2: '',                
                displayName: ''
            }
        }
    },    
    methods:{
        passwordReset(){
            if (this.loginForm.email!='') {
                fb.PasswordReset(this.loginForm.email).then(res=>{
                    this.$dialog.alert(this.$setDialogMsg('w3-yellow',"Új jelszó","A megadott e-mail-címre kiküldtük az új jelszó beállításához szükséges hivatkozást."));
                    this.isRegistration=false;
                }).catch(e=>{
                    console.log(e);                    
                    this.$dialog.alert(this.$setDialogMsg('w3-red',"Új jelszó beállítása","Hiba történt a művelet során:<br><span class='w3-text-red'>"+err.message+"</span>"));                
                }) 
            } else {
                this.$dialog.alert(this.$setDialogMsg('w3-yellow',"Új jelszó beállítása","Add meg az e-mail-címed!"));                
            }
        },     
        signup(){
            if (this.signupForm.displayName=='') {
                this.$dialog.alert(this.$setDialogMsg('w3-red',"Regisztáció","A név mező kitöltése kötelező!"));
                return false;
            }
            if (this.signupForm.password!=this.signupForm.password2) {
                this.$dialog.alert(this.$setDialogMsg('w3-red',"Regisztáció","A két jelszó mező nem egyezik!"));                
                return false;
            }
            if (!this.isDataRules) {
                this.$dialog.alert(this.$setDialogMsg('w3-red',"Regisztáció","Az adatkezelési szabályzatot el kell fogadni!"));                
                return false;
            }
            fb.SignUp(this.signupForm).then(res=>{
                this.$dialog.alert(this.$setDialogMsg('w3-yellow',"Regisztáció","A regisztráció befejezéséhez kérjük hitelesítsd a megadott e-mail-címet a kiküldött levélben található linkre kattintva.<br>Az e-mail-cím hitelesítését követően bejelentkezhetsz."));                
                this.isRegistration=false;
            }).catch(e=>{
                this.$dialog.alert(this.$setDialogMsg('w3-red',"Regisztációs hiba","Hiba történt a regisztráció során:<br><span class='w3-text-red'>"+e.message+"</span>"));                
                console.log(e);                
            })             
        },        
        login(mod){
            this.$storage.set('isLoginProcess', true, { ttl: 60 * 1000 });    //60s, ez a LocalStorage változó azért kell, hogy amikor a google visszadaja az oldalt akkor arra a néhány másodpercre ne jöjjön vissza a bejelentkező oldal        
            fb.SignIn(mod,this.loginForm).then(res=>{
                console.log('Sikeres bejelentkezés...');
             }).catch(e=>{                         
                this.$storage.set('isLoginProcess', false);
                this.isLoginProcess=false;
                this.$dialog.alert(this.$setDialogMsg('w3-red',"Bejelentkezési hiba","Hiba történt a bejelentkezés során:<br><span class='w3-text-red'>"+e.message+"</span>")).then(r=>{
                    store.commit('setUserProfile',null);  
                });
            })  
        },  
        login2(mod){
            if (!this.isDataRules) {
                this.$dialog.alert(this.$setDialogMsg('w3-red',"Regisztáció","Az adatkezelési szabályzatot el kell fogadni!"));                
                return false;
            } else {            
                this.$storage.set('isLoginProcess', true, { ttl: 60 * 1000 });    //60s, ez a LocalStorage változó azért kell, hogy amikor a google visszadaja az oldalt akkor arra a néhány másodpercre ne jöjjön vissza a bejelentkező oldal        
                fb.SignIn(mod,this.loginForm).then(res=>{
                }).catch(e=>{
                    console.log(e);                    
                    this.$storage.set('isLoginProcess', false);
                    this.isLoginProcess=false;
                    this.$dialog.alert(this.$setDialogMsg('w3-red',"Bejelentkezési hiba","Hiba történt a bejelentkezés során:<br><span class='w3-text-red'>"+e.message+"</span>"));
                })                       
            }
        }                                          
    },
    computed: {
        loginSuccess: function () {
            var ls=this.$store.getters.isLogin && this.$store.getters.isProfileLoad;
            if (ls) this.$router.push('/');
            return ls;
        }
    }, 
    mounted: function(){ 
        if (this.$route.params.id=="reg") this.isRegistration=true;
    }
     
}
</script>
